/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { resetInputedValue } from '../../utils/helpers/table/tableHelper';
import { TableStyles } from './table/tableCss';
import { useNavigate } from 'react-router-dom';
import FiltersForms from './filter/FiltersForms';
import {
  createSpatialFilter,
  defineCommuneOrCollectionPoolFilter,
  calculateBlackPoint,
  calculateDebouchage,
  provideDataForHydroTable,
} from '../../utils/helpers/module/hydroHelper';
import { getDataIndus } from '../../utils/helpers/module/indusHelper';
import {
  ecpGetDataTable,
  filtersFormated,
  getData,
  handleCallback,
  indusCreateInputQuery,
  updateData,
} from '../../utils/helpers/module/moduleComponentHelper';
import { defineDefinitionExpression } from '../../utils/helpers/map/defExpHelper';
import { LocalStorage } from '../../utils/localStorage';
import { getMostRecentCategDate } from '../../utils/helpers/table/dateComponentHelper';
import RenderTableDatas from './table/renderTableDatas';
import { getEcpTableData, isBlackChecked } from '../../utils/helpers/module/ecpHelper';
import { loaderDataComponent } from '../../utils/helper';
import ResetStyleComponent from '../cssSaur/resetStyleComponent';

interface Props {
  module: string;
  allBc?: any;
  allInseeCodesContract?: any;
  extent?: any;
  linears?: any;
  layers: any;
  option?: string;
  arcgisUpdate?: (query: string, spatialFilter: any) => Promise<void>;
  zoomToPointTrigger?: (point: {x: number, y: number}) => void;
};

const ModuleComponent = ({
  module,
  allBc,
  allInseeCodesContract,
  extent,
  linears,
  layers,
  option,
  arcgisUpdate,
  zoomToPointTrigger
}: Props) => {
  const roles = LocalStorage.userRole.get();
  const [dataTable, setDataTable] = useState<any[]>([]);
  const [dataDetail, setDataDetail] = useState<any>([]);
  const sessionContractCode = window.sessionStorage.getItem('contractCode');
  const contractLabel = window.sessionStorage.getItem('contractLabel');
  const history = useNavigate();
  // for hydro module
  const [countIndicator, setCountIndicator] = useState(0);
  const [lengthIndicator, setLengthIndicator] = useState(0);
  const [indicator, setIndicator] = useState('0');
  const [blackPoint, setBlackPoint] = useState(0);
  const [dataDate, setDataDate] = useState('');
  const [prevFilters, setPrevFilters] = useState({});
  const [loading, setLoading] = useState(false);

  // provide data for table of hydro
  const getHydroData = async (
    pBcAndCommuneHydro: any,
    pAsset: any,
    pMode: string,
    pFilters: object
  ) => {
    // update table
    const data = await provideDataForHydroTable(extent, pAsset.definitionExpression);

    // avoit to update indicators when the extent is changed and also when no data are found
    if (data.dataTable.length > 0 && pMode === 'filter_updated') {
      // hence objectids already got, we can get stats with 303/306 map api
      // calcul indicator for debouchage
      const getStatsDebouchage = calculateDebouchage(
        pAsset,
        pBcAndCommuneHydro,
        pFilters,
        module,
        sessionContractCode!,
        allInseeCodesContract,
        linears
      );
      // get black points indicator
      const getStatsBlackPoint = calculateBlackPoint(pAsset.definitionExpression, pFilters['InseeCode'].name);

      const [debouchage, blackPoint] = await Promise.allSettled([getStatsDebouchage, getStatsBlackPoint]);
      if(debouchage.status === 'fulfilled') {
        setCountIndicator(debouchage.value.count);
        setLengthIndicator(debouchage.value.length);
        setIndicator(debouchage.value.newIndicator.toFixed(3));
      }
      if(blackPoint.status === 'fulfilled') {
        setBlackPoint(blackPoint.value);
      }
    }
    
    if (data.dataTable.length === 0 && pMode === 'filter_updated') {
      // init to 0
      setCountIndicator(0);
      setLengthIndicator(0);
      setIndicator('0');
      setBlackPoint(0);
    }

    // for popup detail
    setDataDetail(data.details);
    // for table module
    setDataTable(data.dataTable);
  };

  // provide data for table
  const setTable = async (filters: any, param?) => {
    setDataTable([]);
    setDataDetail([]);
    setLoading(true);
    // get collectionPoolsList
    const collectionPools = Object.assign([], filters.CollectionPools);
    delete filters.CollectionPools;
    // create query for map
    let query = defineDefinitionExpression(
      filters,
      module,
      window.sessionStorage.getItem('contractCode')
    );
    switch (module) {
      case 'ecp':
        // ecp case
        const ecpData = await ecpGetDataTable(
          query,
          param,
          allBc,
          sessionContractCode,
          filters
        );
        arcgisUpdate && arcgisUpdate(ecpData.query, ecpData.mode);
        // add collectionPooId for ecp detail view
        const output = getEcpTableData(
          collectionPools,
          ecpData.data,
          isBlackChecked(filters),
          param
        );
        setDataTable(output);
        return output;
      case 'indus':
        const indusData = await getDataIndus(
          filters,
          query,
          allInseeCodesContract
        );
        setDataTable(indusData);
        // update map
        arcgisUpdate && arcgisUpdate(indusCreateInputQuery(query, indusData), {});
        return indusData;
      case 'hydro':
        let asset = layers.findSublayerById(301);
        if (asset) {
          // need to get extent and update map before getting data
          await getHydroData(
            JSON.parse(window.sessionStorage.getItem('bcAndCommuneHydro')!),
            asset,
            'filter_updated',
            filters
          );
        }
        return;
      default:
        // method to feed table for do, pr, milieu (sensibility and dilution), h2s and pluie modules
        const dataTable = await getData(module, query, option);        
        setDataTable(dataTable);
        resetInputedValue(dataTable, module);        
        return dataTable;
    }
  };

  const updateTableAndMap = async (pFilters: object) => {
    const filterFormated = filtersFormated(pFilters, module);
    let query = defineDefinitionExpression(
      filterFormated.filters,
      module,
      window.sessionStorage.getItem('contractCode')
    );
    // specific cases
    if (module !== 'hydro') {
      let collectionPoolCode =
        module === 'ecp' &&
        filterFormated.filters['Code'] &&
        filterFormated.filters['Code'].code
          ? filterFormated.filters['Code'].code
          : '';      
      setTable(
        filterFormated.filters,
        collectionPoolCode
      ).then(() => {
        // update map
        // exeption for Color filter
        if (module !== 'indus' && module !== 'ecp') {
          let queryUpdated = query;
          if (module !== 'h2s' && filterFormated.fieldName !== 'Color') {
            queryUpdated = query.replace(filterFormated.fieldName, 'Color');
          }
          arcgisUpdate && arcgisUpdate(queryUpdated, {});
        }
        setLoading(false);
      });
    } else {
      // for hydro module
      // get objectids of 303/306, to get stats
      const filteBcOrCommune = await createSpatialFilter(
        filterFormated.filters,
        allBc,
        allInseeCodesContract,
        query,
      );
      window.sessionStorage.setItem(
        'bcAndCommuneHydro',
        JSON.stringify(filteBcOrCommune)
      );
      const filterToAdd = defineCommuneOrCollectionPoolFilter(
        filteBcOrCommune,
        allInseeCodesContract,
        'inter',
        query,
      );
      const buidQuery = filterToAdd !== '' ? query + ' AND ' + filterToAdd : query;
      // content of map provide and update the table
      arcgisUpdate && arcgisUpdate(buidQuery, filteBcOrCommune).then(
        () => {
          setTable(filterFormated.filters, '').then(() => {
            setLoading(false);
          });
        }
      );
    }
    setPrevFilters(pFilters);
  };

  useEffect(() => {
    // show categ date
    if (
      dataTable.length !== 0
    ) {
      const date = getMostRecentCategDate(
        dataTable,
        option !== undefined ? option : module
      );
      setDataDate(date);
    } else {
      setDataDate(loading ? 'Chargement en cours...' : 'Aucune donnée trouvée');
    }
  }, [dataTable]);

  // used to update table when you move on the map for hydro module
  useEffect(() => {
    let asset = layers.findSublayerById(301);
    // we need to have an extent not null and the asset of layer to update it
    if (
      extent !== '' &&
      module === 'hydro' &&
      asset &&
      asset.definitionExpression !== null
    ) {
      setLoading(true);
      updateData(asset, getHydroData, prevFilters).then(() => {
        setLoading(false);
      });
    }
  }, [extent]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container
      className={'sds-reset-style global-filter-form-' + module}
      id={'global-filter-form-' + module}
    >
      <ResetStyleComponent />
      <Styles />
      {/* Filters */}
        <FiltersForms
          module={module}
          parentCallback={(pFilters: object) =>
            handleCallback(pFilters, prevFilters, updateTableAndMap)
          }
          allBc={allBc}
          allInseeCodesContract={allInseeCodesContract}
          option={option}
        />
      {/* Table */}
      <Card automatedTestId={module + '-table-id'}>
          <RenderTableDatas
            module={module}
            dataDetail={dataDetail}
            history={history}
            option={option}
            indicator={indicator}
            countIndicator={countIndicator}
            lengthIndicator={lengthIndicator}
            blackPoint={blackPoint}
            dataTable={dataTable}
            dataDate={dataDate}
            prevFilters={prevFilters}
            roles={roles}
            contractLabel={contractLabel}
            updateTableAndMap={updateTableAndMap}
            zoomToPointTrigger={zoomToPointTrigger}
          />
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};

const Styles = TableStyles;

export default ModuleComponent;
